import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      {value === index && (
        <Box className="py-3 pr-3 pl-14">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    width: "100%",
    height: "100%",
  },
  indicator: {
    width: "100%",
    backgroundColor: "#ccc",
    opacity: "30%",
  },
  tabs: {
    width: "15%",
  },
  tab: {
    width: "100%",
    fontSize: "15px",
    fontFamily: "GmarketSansMedium",
    textTransform: "none",
    textAlign: "left",
    padding: "20px",
  },
  tabPanel: {
    width: "85%",
  },
}));

const TermsPC = ({ tabList }) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="page-content w-full pt-12 pb-36">
      <div className={`${classes.root} flex`}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          classes={{
            indicator: classes.indicator,
            tabs: classes.tabs,
          }}
        >
          {tabList ? tabList.map((m, index) => <Tab key={index} label={m.title} {...a11yProps(index)} className={classes.tab} />) : ""}
        </Tabs>
        {tabList
          ? tabList.map((m, index) => (
              <TabPanel value={value} index={index} className={classes.tabPanel} key={index}>
                {m.content}
              </TabPanel>
            ))
          : ""}
      </div>
    </div>
  );
};

export default TermsPC;
